module.exports = __webpack_public_path__ + "static/media/LOSS2.34d9197.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/LOSS2.mp3
// module id = 266
// module chunks = 1 2 3 4